import { useContext } from "react";
import { ReactAudioContext } from "./context";

const useReactAudioContext = () => {
  const value = useContext(ReactAudioContext);
  if (!value) throw new Error('OH no!! Missing AudioProvider in the tree');
  return value;
};

export {
  useReactAudioContext
}